import { useMutation } from '@apollo/client'

import { CreateProductDocument } from '@/graphql/purchase-plus/generated/createProduct.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

export const useCreateProduct = () => {
  const mutation = useMutation(CreateProductDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return mutation
}
